import axios from "axios";
import app from "../main";
import router from "../router";
import { EventBus } from "@/eventBus";
import browserLocation from "@/helpers/BrowserLocation";
import AuthToken from "@/helpers/AuthToken";
import store from "@/modules";

import { has } from "lodash";

const cleanUpStore = () => {
  store.commit("db/shared/resetState", null, { root: true });
  store.commit("db/account/resetState", null, { root: true });
  store.commit("db/devices/resetState", null, { root: true });
  store.commit("db/requests/resetState", null, { root: true });
  store.commit("db/account/location/resetState", null, { root: true });
};

let counter = { times: 0 };

let finishProgress = (progress, action = "finish") => {
  setTimeout(() => {
    counter.times = counter.times - 1;
    if (counter.times === 0) progress[action].call(progress);
  }, 600);
};

export default function setup() {
  axios.interceptors.request.use(
    function (config) {
      config.headers.common["X-APP"] = "ND";
      const token = localStorage.getItem("@token_id");
      if (token) {
        config.headers.common["Authorization"] = `Bearer ${token}`;

        if (
          has(config.headers, "X-CUSTOMER-AUTH") &&
          config.headers["X-CUSTOMER-AUTH"].toString() === "0"
        ) {
          delete config.headers["X-CUSTOMER-AUTH"];
        } else {
          let customerId = store.getters["db/account/customerId"];
          if (customerId && !isNaN(customerId)) {
            config.headers.common["X-CUSTOMER-AUTH"] = customerId;
          }
        }
      }
      config.headers.common["Accept"] = "application/json";
      config.headers.common["Content-Type"] = "application/json";
      config.headers.common["Access-Control-Allow-Origin"] = "*";
      config.headers.common["Access-Control-Allow-Headers"] =
        "Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin";
      counter.times = counter.times + 1;
      if (app.$Progress.$vm.$data.RADON_LOADING_BAR.percent === 0) {
        app.$Progress.start();
      }
      return config;
    },
    function (err) {
      finishProgress(app.$Progress, "fail");
      return Promise.reject(err);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      browserLocation.save(false);
      AuthToken.init().save(response.headers["access-token"]);
      finishProgress(app.$Progress);
      return Promise.resolve(response);
    },
    (error) => {
      finishProgress(app.$Progress, "fail");

      if (error.response === undefined) {
        return Promise.reject(error);
      }

      if (error.response.status === 401) {
        cleanUpStore();
        console.log(`Redirect to login: ${error.response.status}`);
        router.push("/login");
      }

      if (error.response.status === 451) {
        EventBus.$emit("action-no-authorized");
      }

      return Promise.reject(error.response);
    }
  );
}
